import { INITIAL_FILTER_VALUE, JOB_FILTER_LOCALSTORAGE_KEY } from "@/constants/pages/clients/jobs/jobs";



// helper to get user from localstorage
export function getJobFilter() 
{
  if (typeof window !== 'undefined') 
  {
    var storedUser = localStorage.getItem(JOB_FILTER_LOCALSTORAGE_KEY);

    if(storedUser=='undefined' || storedUser == null)
    {
      setJobFilter(INITIAL_FILTER_VALUE);
      storedUser = localStorage.getItem(JOB_FILTER_LOCALSTORAGE_KEY);
    }
    return storedUser ? JSON.parse(storedUser) : null;
  }
}

export function setJobFilter(filters) 
{
  if (typeof window !== 'undefined') 
  {
    localStorage.setItem(JOB_FILTER_LOCALSTORAGE_KEY, JSON.stringify(filters));
  }
}

export function clearJobFilter() 
{
  if (typeof window !== 'undefined') {
    localStorage.removeItem(JOB_FILTER_LOCALSTORAGE_KEY);
  }
}
